import ApiBase from 'services/base/apiBase';

export class SubscribtionPlansService {
  private static apiBase = new ApiBase();

  public static getPlansData(): Promise<any> {
    return this.apiBase.getAsync(`/subscription/`);
  }

  public static getInvoiceData(): Promise<any> {
    return this.apiBase.getAsync(`/subscription/invoices/`);
  }

  public static getPlans(): Promise<any> {
    return this.apiBase.getAsync('/subscription/plans/');
  }

  public static async getCheckoutSession(planID: string): Promise<any> {
    try {
      const response = await this.apiBase.postAsync(
        `/subscription/checkout/session/`,
        {
          planID: planID
        }
      );
      return response;
    } catch (error) {
      console.error('Error in getCheckoutSession:', error);
      throw error;
    }
  }

  public static getSubscriptionPortal(): Promise<any> {
    return this.apiBase.postAsync('/subscription/customer/portal/', {});
  }
}
